import "core-js/modules/web.timers.js";
import { defineComponent, onMounted, ref } from 'vue';
export default defineComponent({
  name: "Toast",
  props: {
    options: {
      validator: function validator(_ref) {
        var text = _ref.text,
            show = _ref.show;
        return typeof text === "string" && typeof show === "boolean";
      },
      "default": function _default() {
        return {
          text: "",
          show: false,
          useTransition: false
        };
      }
    }
  },
  emits: ['update:options'],
  setup: function setup(props, context) {
    var timer = ref(null);
    var show = ref(null);
    onMounted(function () {
      show.value = props.options.show;
    });

    var createTimer = function createTimer() {
      timer.value = setTimeout(function () {
        context.emit("update:options", false);
      }, 2000);
    };

    var afterEnter = function afterEnter() {
      createTimer();
    };

    return {
      timer: timer,
      show: show,
      createTimer: createTimer,
      afterEnter: afterEnter
    };
  }
});